import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';

import { Events } from '../interfaces/events.interface';

@Injectable({ providedIn: 'root' })
export class AuditEventService {
  private readonly url: string = `${environment.url}/audit/events`;

  constructor(private http: HttpClient) {}

  selectDocument(key: string, button: string): Observable<Events> {
    return this.http.post<Events>(this.url, [
      {
        kind: 'document_select',
        key: '-',
        data: { document: key, button: button },
      },
    ]);
  }

  allowFieldChange(key: string): Observable<Events> {
    return this.http.post<Events>(this.url, [
      { kind: 'field_allow_change', key: key, data: {} },
    ]);
  }

  approveField(key: string): Observable<Events> {
    return this.http.post<Events>(this.url, [
      { kind: 'field_approved', key: key, data: {} },
    ]);
  }

  reproveField(key: string): Observable<Events> {
    return this.http.post<Events>(this.url, [
      { kind: 'field_reproved', key: key, data: {} },
    ]);
  }

  changeFieldValue(key: string, value: any): Observable<Events> {
    return this.http.post<Events>(this.url, [
      { kind: 'field_change', key: key, data: { value: value } },
    ]);
  }

  reproveImage(key, reasons, note): Observable<Events> {
    return this.http.post<Events>(this.url, [
      {
        kind: 'image_reprove',
        key: key,
        data: { reasons: reasons, note: note },
      },
    ]);
  }

  approveImage(key): Observable<Events> {
    return this.http.post<Events>(this.url, [
      { kind: 'image_approve', key: key, data: {} },
    ]);
  }

  selectImage(key: string, button: string): Observable<Events> {
    return this.http.post<Events>(this.url, [
      { kind: 'image_select', key: '-', data: { image: key, button: button } },
    ]);
  }

  timeoutAudit(): Observable<Events> {
    return this.http.post<Events>(this.url, [
      { kind: 'audit_timeout', key: '-', data: {} },
    ]);
  }

  finishAudit(): Observable<Events> {
    return this.http.post<Events>(this.url, [
      { kind: 'audit_finish', key: '-', data: {} },
    ]);
  }

  withdrawalAudit(): Observable<Events> {
    return this.http.post<Events>(this.url, [
      { kind: 'audit_withdrawal', key: '-', data: {} },
    ]);
  }
}
